import { ActionCreator, ActionCreatorsMapObject, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { IErrorsState, IErrorsAction } from './ErrorsModel';
import axios from 'axios';
import config from '../../../../auth.config';
import { sec } from '../../../../security';

const API_ROOT = process.env.REACT_APP_API_ROOT;

export const getErrors: ActionCreator<
    ThunkAction<Promise<any>, IErrorsState, null, IErrorsAction>
> =
    (
        fileImportStatusId: string,
        limit: number,
        skip: number,
        sort: string,
        direction: string
    ) =>
    async (dispatch: Dispatch) => {
        dispatch({ type: 'FETCH_ERRORS_REQUEST' });

        try {
            const access_token = await sec.getAccessTokenSilently()({
                scope: config.scope,
                audience: config.audience,
            });

            const response = await axios.get(
                `${API_ROOT}/file/import/errors/${fileImportStatusId}`,
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json;charset=UTF-8',
                        Accept: 'application/json',
                        Authorization: `Bearer ${access_token}`,
                    },
                    params: {
                        fileImportStatusId,
                        skip,
                        limit,
                        sort,
                        direction,
                    },
                }
            );

            dispatch({ type: 'FETCH_ERRORS_SUCCESS', payload: response.data });
        } catch (error: any) {
            dispatch({ type: 'FETCH_ERRORS_FAILURE', error: error.message });
        }
    };

export const downloadErrors: ActionCreator<
    ThunkAction<Promise<void>, IErrorsState, null, IErrorsAction>
> = (fileImportId: string, fileName: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'FETCH_ERRORS_DOWNLOAD_REQUEST' });

    try {
        const access_token = await sec.getAccessTokenSilently()({
            scope: config.scope,
            audience: config.audience,
        });

        const response = await axios.get(
            `${API_ROOT}/file/download/errors/${fileImportId}`,
            {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json;charset=UTF-8',
                    Accept: 'application/json',
                    Authorization: `Bearer ${access_token}`,
                },
                responseType: 'blob',
            }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `errors_${fileName}.csv`);
        document.body.appendChild(link);
        link.click();

        dispatch({ type: 'FETCH_ERRORS_DOWNLOAD_SUCCESS' });
    } catch (error: any) {
        dispatch({
            type: 'FETCH_ERRORS_DOWNLOAD_FAILURE',
            error: error.message,
        });
    }
};

export const errorActions: ActionCreatorsMapObject<
    ThunkAction<Promise<any>, any, null, IErrorsAction>
> = {
    getErrors,
    downloadErrors,
};
